import { render, staticRenderFns } from "./tab3.vue?vue&type=template&id=1a91b1a4&scoped=true&"
import script from "./tab3.vue?vue&type=script&lang=js&"
export * from "./tab3.vue?vue&type=script&lang=js&"
import style0 from "./tab3.vue?vue&type=style&index=0&id=1a91b1a4&prod&lang=css&"
import style1 from "./tab3.vue?vue&type=style&index=1&id=1a91b1a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a91b1a4",
  null
  
)

export default component.exports